let pending;
let cachedPages;
export const peekMenuPages = () => cachedPages;
export function loadMenuPages(retry = false) {
  if (retry) { pending = null; cachedPages = null; }
  if (!pending) pending = fetch('/menu-pages.json')
    .then(response => { if (!response.ok) throw new Error('Menu unavailable'); return response.json(); })
    .then(data => {
      const pages = data.filter(page => page.status === 'active').sort((a, b) => a.page_number - b.page_number);
      if (!pages.length) throw new Error('Empty menu');
      cachedPages = pages;
      return pages;
    }).catch(error => { pending = null; throw error; });
  return pending;
}
